import customIcons from '@wienenergiegithub/ui-next/src/common/assets/icons/wienenergiecustom.fontawesome';
import solid from '@wienenergiegithub/ui-next/src/common/assets/icons/solid';
import regular from '@wienenergiegithub/ui-next/src/common/assets/icons/regular';
import brands from '@wienenergiegithub/ui-next/src/common/assets/icons/brands';
import { library } from '@fortawesome/fontawesome-svg-core';

export default function registerFontAwesomeIcons() {
  library.add(...brands);
  library.add(...regular);
  library.add(...solid);

  library.add(...customIcons);
}
